import { GameState } from '@/models/games/enums/GameState';
import { getHostById } from '@/modules/host/slice';
import { getHostLiveDataByHostId } from '@/modules/hostLive/slice';
import { RootState } from '@/store/store';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useIsBettingInfo = (hostId: number) => {
    const { IsRest } = useSelector((state: RootState) =>
        getHostById(state, hostId)
    );
    const { CurrentResult, CurrentState } = useSelector((state: RootState) =>
        getHostLiveDataByHostId(state, hostId)
    );
    const isBetting = useMemo(
        () => (IsRest ? false : CurrentState === GameState.Betting),
        [IsRest, CurrentState]
    );
    const isShuffling = useMemo(
        () => CurrentResult?.GameCount === 0,
        [CurrentResult]
    );

    return { isBetting, isShuffling, CurrentResult, IsRest };
};
